import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  display: flex;
  padding: 0 1rem;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme["line"]};
  gap: 0.5rem;
  ${({theme}) => theme.breakpoints.up("lg")} {
    gap: unset;
  }
`;
